// extracted by mini-css-extract-plugin
export default {"loaderWrapper":"loader_loaderWrapper__WEOjg","loader":"loader_loader__3lTeP"};